<section class="new_login_section">
  <div class="logo_div">
    <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Header/logo.png" class="logo">
  </div>
  <div class="login_flex_box">
    <div class="left_section">
      <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Login/login_left_img.svg" class="login_left_img">
      <h1>The Godfather of Accountants<br/> Welcomes you!</h1>
    </div>
    <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Login/line.svg" class="line_img">
    <div class="right_section">
      <p class="forgot_pwd_heading"><span routerLink="login" style="cursor: pointer;"><img
            src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Login/left_arrow.svg"></span> Forgot
        Password?</p>
      <form [formGroup]="fetchPassword">
        <div style="position: relative;">
          <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Login/mailIcon.svg"
            class="left_icon">
          <input type="text" class="form_control" name="registered_email" formControlName="registered_email"
            placeholder="Registered email id">
        </div>
        <button type="button" class="blue_btn" (click)="submit()">Request</button>
      </form>
    </div>
  </div>
</section>

<!-- <section class="login_section d-none">
  <div class="view rgb-gradient d-flex justify-content-center align-items-center">
    <div class="mask " style="position: relative;">
      <div class="container pb-5">
        <div class="col-lg-5 col-md-8 col-sm-9 mx-auto my-5">
          
          <mdb-card class="wow fadeInRight" data-wow-delay="0.3s"
            style="border-radius: 15px; background: rgb(255 255 255 / 60%);">
            <mdb-card-body class="p-2 p-sm-2 p-md-3 p-lg-3">
              <form [formGroup]="fetchPassword" class="pt-4 login-form">
                <div class="login__logo" style="margin:0 auto 50px auto;">
                  <a href="#" target="_blank" rel="noopener noreferrer">
                    <img
                      src="https://storage.googleapis.com/miles-next_website-lms-gptool/educational_documents/Miles%20Website%20Images/home/MilesEducation_Main_Logo.png"
                      alt="Miles CPA LMS" style="width: 12vw; margin: auto;">
                  </a>
                </div>
                <div class="text-center">
                  <h4 class="dark-grey-text f-20 font-weight-bolder text-uppercase">Unable To Login ?</h4>
                  <p class="pb-2" style="line-height: 1.2; font-size: 16px;">Enter your registered email to receive
                    password</p>
                </div>

                <div class="md-form md-outline my-4">
                  <mdb-icon fas icon="envelope" class="prefix text-black-50"></mdb-icon>
                  <input type="text" id="inputIconEx1" class="form-control" mdbInput mdbValidate
                    formControlName="registered_email"
                    style="box-shadow: inset 0 0 5px rgba(0,0,0,0.1), inset 0 3px 2px rgba(0,0,0,0.1); border-radius: 3px; background: #f9f9f9; border-radius: 5px;">
                  <label for="inputIconEx1">Enter Registered Email</label>
                </div>
                <hr>
                <div class="justify-content-center row">
                  <div class="pt-2 text-center">
                    <button mdbBtn gradient="blue" size="md"
                      style="background: linear-gradient(40deg, #4178d9, #0044ba) !important;" mdbWavesEffect
                      (click)="submit()">Request</button>
                  </div>
                </div>
              </form>
            </mdb-card-body>
          </mdb-card>
        </div>
      </div>
    </div>
  </div>
</section> -->